module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/terminal-92af89cfa8d47c02adae11eb3e7f907c.svg";